module.exports = __webpack_public_path__ + "img/video_interativo_estudio.268a363a.jpg";